import { RefValue } from './IncidentSignals'
import { formatIncidentDate } from './incidentFormatting'
import type { IncidentTimelineEvent } from './types'

function TimelineRefs({ event }: { event: IncidentTimelineEvent }) {
  if (event.operatorNavigationRefs.length === 0) return <>—</>

  return (
    <div className="flex flex-col gap-1">
      {event.operatorNavigationRefs.map((item) => (
        <span key={`${event.id}-${item.kind}`} className="break-all">
          <span className="font-medium">{item.label}:</span> <RefValue item={item} />
        </span>
      ))}
    </div>
  )
}

function TimelineEventText({ event }: { event: IncidentTimelineEvent }) {
  return (
    <>
      <div className="text-sm text-foreground">{event.summary}</div>
      {event.normalizedError && <div className="text-xs text-muted-foreground mt-1">{event.normalizedError}</div>}
    </>
  )
}

export function IncidentTimeline({ timeline }: { timeline: IncidentTimelineEvent[] }) {
  return (
    <section>
      <h3 className="text-sm font-semibold text-foreground mb-2">Timeline</h3>

      <div className="hidden md:block bg-card border border-border rounded-lg overflow-hidden">
        <table className="w-full">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground uppercase">Quando</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground uppercase">Fonte</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground uppercase">Evento</th>
              <th className="text-left px-4 py-3 text-xs font-medium text-muted-foreground uppercase">Refs</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {timeline.map((event) => (
              <tr key={event.id}>
                <td className="px-4 py-3 text-sm text-muted-foreground whitespace-nowrap">{formatIncidentDate(event.observedAt)}</td>
                <td className="px-4 py-3 text-sm text-foreground">{event.source}</td>
                <td className="px-4 py-3"><TimelineEventText event={event} /></td>
                <td className="px-4 py-3 text-xs text-muted-foreground"><TimelineRefs event={event} /></td>
              </tr>
            ))}
            {timeline.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-sm text-muted-foreground">Nenhum evento redigido vinculado.</td></tr>}
          </tbody>
        </table>
      </div>

      <div className="md:hidden space-y-3">
        {timeline.map((event) => (
          <article key={event.id} className="bg-card border border-border rounded-lg p-3 space-y-3">
            <div className="flex items-start justify-between gap-3">
              <div className="text-xs text-muted-foreground">{formatIncidentDate(event.observedAt)}</div>
              <div className="text-xs font-medium text-foreground text-right break-all">{event.source}</div>
            </div>
            <TimelineEventText event={event} />
            <div className="text-xs text-muted-foreground">
              <TimelineRefs event={event} />
            </div>
          </article>
        ))}
        {timeline.length === 0 && (
          <div className="bg-card border border-border rounded-lg px-4 py-8 text-center text-sm text-muted-foreground">
            Nenhum evento redigido vinculado.
          </div>
        )}
      </div>
    </section>
  )
}
